<div class="not-found-container">
    <h2>404 - Not Found</h2>
    <p>The page you are looking for might be under construction or does not exist.</p>
</div>